import { render, staticRenderFns } from "./createProject.vue?vue&type=template&id=f44195ec&"
import script from "./createProject.vue?vue&type=script&lang=js&"
export * from "./createProject.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports